import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import RoomsSection from "@/components/RoomsSection";
import RegionSection from "@/components/RegionSection";
import FaqSection from "@/components/FaqSection";
import Footer from "@/components/Footer";

export default function LandingPage() {
  return (
    <main data-testid="landing-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Manifesto />
      <RoomsSection />
      <RegionSection />
      <FaqSection />
      <Footer />
    </main>
  );
}
